import { gql } from '@apollo/client';
import STUDY_SETTING_FRAGMENT from '../fragments/studySettingFragment';

const ASSIGN_DEVICE_TO_STUDY_MUTATION = gql`
  mutation assignDeviceToStudy($input: AssignDeviceInput) {
    assignDeviceToStudy(input: $input) {
      isSuccess
      message
      study {
        id
        device {
          deviceId
          model
        }
        isDeviceAssignmentPending
        info {
          studySetting {
            ...StudySettingFragment
          }
        }
      }
    }
  }

  ${STUDY_SETTING_FRAGMENT}
`;

export default ASSIGN_DEVICE_TO_STUDY_MUTATION;
